import classNames from "classnames";
import homeGarageStyles from "./StyledHomeGarage.module.scss";
import VehicleDescription from "./VehicleDescription";
import styles from "./homeGarageVehicleSelected.module.scss";

function HomeGarageCompactVehicleSelected(props) {
  const { isCompactGarage, onChangeVehicle } = props;

  return (
    <div className={`home-garage ${homeGarageStyles.StyledHomeGarage}`} style={isCompactGarage ? { padding: 0 } : {}}>

      <div className={classNames("garage-xs", {
        [styles.compact_vehicle]: isCompactGarage,
      })}
      >

        <VehicleDescription
          isCompactGarage={isCompactGarage}
          onChangeVehicle={onChangeVehicle}
        />

      </div>
    </div>
  );
}

export default HomeGarageCompactVehicleSelected;
